import 'twin.macro';
import 'styled-components/macro';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { MenuItem } from './MenuItem';
import { MenuList } from './MenuList';

export interface MainMenuProps {
  title?: string;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  team?: string;
}

export const MainMenu: FC<MainMenuProps> = ({
  title,
  shouldHideContent,
  shouldHideInspirationLibrary,
  team,
  ...props
}) => {
  const inspirationLibraryPath = `/${team}/inspiration-library`;

  return (
    <MenuList title={title} tw="sm:mt-0 sm:flex sm:space-x-3" {...props}>
      {!shouldHideContent && (
        <NavLink to={`/${team}`}>
          <MenuItem>Content</MenuItem>
        </NavLink>
      )}
      {!shouldHideInspirationLibrary && (
        // Not usign the `active` prop since `MainMenu` is never rendered on the
        // Inspiration Library page.
        <NavLink to={inspirationLibraryPath}>
          <MenuItem>Inspiration Library</MenuItem>
        </NavLink>
      )}
    </MenuList>
  );
};
